import { ReactNode, useEffect } from 'react';
import { usePermissions } from '@refinedev/core';
import { useQueryClient } from '@tanstack/react-query';
import { IResource, Role } from './types';

interface IAccessControlProviderProps {
  children: ReactNode;
  resources: Array<IResource>;
  dataprovider: {
    loadPermissionsContext: (resources: Array<IResource>, userRoles: Array<Role>) => void;
  };
}

export const AccessControlConfig = ({
  children,
  resources,
  dataprovider,
}: IAccessControlProviderProps) => {
  const { data: userRoles } = usePermissions({});
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!userRoles) {
      return;
    }

    dataprovider.loadPermissionsContext(resources, userRoles as Array<Role>);
    queryClient.invalidateQueries({ queryKey: ['access'] });
  }, [dataprovider, queryClient, resources, userRoles]);

  return children;
};
